import request from '@/utils/request'

/**
 * 示例写法
 */
// 导出 常量   名称       参   函数
export const example = (data) => {
  // 返回 axios
  return request({
    url: '/api/url', // 接口地址
    method: 'POST', // 请求方法 默认GET
    data // 参数 ES6写法
  })
}
//
// 获取首页banner图
export const getBanner = (params) => {
  // 返回 axios
  return request({
    url: '/api/pc/home/banner/list',
    method: 'GET',
    params
  })
}
//  获取系统配置
export const getConfig = (params) => {
  return request({
    url: '/system/config/byName/list',
    method: 'GET',
    params
  })
}
// 通过key获取系统配置
export function getConfigKey(k) {
  return request({
    url: '/system/config/byName/' + k,
    method: 'GET'
  })
}

// 获取广告列表
export function adList(params) {
  return request({
    url: '/api/pc/home/ad/list',
    method: 'GET',
    params
  })
}
// 获取合作机构列表
export function getPartner(params) {
  return request({
    url: '/api/pc/home/cooperation/list',
    method: 'GET',
    params
  })
}
// 获取底部链接列表
export function getEssay(params) {
  return request({
    url: '/api/pc/home/bottom/list',
    method: 'GET',
    params
  })
}
// 获取文章内容
export function getEssayDetail(params) {
  return request({
    url: '/api/pc/home/article/list',
    method: 'GET',
    params
  })
}
// 新增代理申请
export const addAgency = (data) => {
  return request({
    url: '/api/pc/home/apply/add',
    method: 'POST',
    data
  })
}
// 获取seo设置
export const getSeoSet = (data) => {
  return request({
    url: '/api/pc/home/seo/list',
    method: 'GET',
    data
  })
}
// 获取app版本
export function getAPPDownloadList(params) {
  return request({
    url: '/api/appVersion/list',
    method: 'GET',
    params
  })
}
// 新增反馈
export const addFeedback = (data) => {
  return request({
    url: '/api/user/addFeedBack',
    method: 'POST',
    data
  })
}
